import styles from '../DynamicPageTemplate/DynamicPageTemplate.module.css';

export const Section = ({
  ariaLabel,
  className,
  content,
  dataTestId,
  id,
  show,
}: {
  ariaLabel: string;
  className: string;
  content: JSX.Element | (JSX.Element | null)[] | null;
  dataTestId?: string;
  id: string;
  show: boolean;
}) => (
  <section
    aria-label={ariaLabel}
    className={`${className} ${show ? styles.show : ''}`}
    data-testid={dataTestId}
    id={id}
  >
    {content}
  </section>
);
